import { type RecordId } from 'javascripts/shared-types';

/**
 * Given a record with a name, return a tuple with the name and the id
 */
const nameMap: (item: {
  name: string;
  id: RecordId;
}) => [string, RecordId] = item => [item.name, item.id];

export { nameMap };
